import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShortcutsBusService {
  private actionSubject = new Subject<string>();
  action$ = this.actionSubject.asObservable();

  emit(actionName: string) {
    this.actionSubject.next(actionName);
  }
}
